import type { OngoingLoadCounts } from '@numeo/types-core'
import type { TabType } from '../types'

/** The per-tab load counts the board shows next to each tab label: the server's, with the Dispatched tab always set. */
export type OngoingLoadTabCounts = OngoingLoadCounts & { dispatched: number }

type OngoingLoadCountKey = Exclude<keyof OngoingLoadTabCounts, 'allTrips'>

const COUNT_KEY_BY_TAB: Record<TabType, OngoingLoadCountKey | null> = {
    upcoming: 'upcoming',
    dispatched: 'dispatched',
    'in-transit': 'inTransit',
    history: 'history',
    'all-trips': null,
}

/** The count a tab owns; All Trips owns none of its own — it is the sum of the others. */
export const tabToCountKey = (tab: TabType): OngoingLoadCountKey | null => COUNT_KEY_BY_TAB[tab]
